import Instance from '../request';

export default {
  getDataview() {
    return Instance.get('/data-view/odd');
  }
};
